import Fraction from 'fraction.js'

const prettyScale = [
  { from: '1/8', to: '⅛' },
  { from: '1/6', to: '⅙' },
  { from: '1/5', to: '⅕' },
  { from: '1/4', to: '¼' },
  { from: '1/3', to: '⅓' },
  { from: '1/2', to: '½' },
  { from: '2/3', to: '⅔' },
  { from: '2/5', to: '⅖' },
  { from: '3/8', to: '⅜' },
  { from: '3/5', to: '⅗' },
  { from: '3/4', to: '¾' },
  { from: '4/5', to: '⅘' },
  { from: '7/8', to: '⅞' },
  { from: '5/8', to: '⅝' },
  { from: '5/6', to: '⅚' }
]

export function validateScale (scale) {
  try {
    const value = Fraction(scale).valueOf()
    if (value <= 0 || value > 1000) {
      throw new Error('out of bounds')
    }
    return String(scale)
  } catch (err) {
    return '1'
  }
}

export function scaleToString (scale) {
  const fraction = Fraction(scale).simplify()
  if (fraction.d > 8) {
    return String(scale)
  }
  const str = fraction.toFraction(true)
  for (let ii = 0; ii < prettyScale.length; ii++) {
    if (str.includes(prettyScale[ii].from)) {
      return str.replace(prettyScale[ii].from, prettyScale[ii].to)
    }
  }
  return str
}



// WEBPACK FOOTER //
// ./src/models/scale.js